import styled from 'styled-components';

export const InfoIcon = styled.i`
  cursor: help;
  font-size: 16px;
  vertical-align: middle;
`;
